import { Path } from 'react-native-svg';
import React from 'react';

import { IconDef, IconSpecificStyles } from './types';

export const ArrowUp: IconDef = {
  svg: (
    <Path
      d="M15.9976 13.4982L10.9958 8.49989L5.99756 13.5016"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
